<script>
  import { parse } from "svelte/compiler";

	//let exchangeRate = 152.8;
	let exchangeRate = 159;
	let displayDetails = false;
  
	// const weightPricesAir = [
	//   0, 590, 850, 1350, 1650, 2150, 2350, 2500, 3250, 3500, 3750, 4250, 4750, 5250, 5750, 6250, 6750, 6850, 7350, 7500,
	//   7750
	// ];
	
  const weightPricesAir = [
		800, 1200, 1600, 2050, 2450, 2800, 3250, 3650, 4150, 4500, 5050, 5500, 5950, 
		6300, 6750, 7100, 7550, 7950, 8350, 8800, 9200, 9600, 10000, 10400, 10800, 
		11200, 11600, 12000, 12400, 14400, 14880, 15360, 15840, 16320, 16800, 17280, 
		17760, 18240, 18720, 19200, 19680, 20160, 20640, 21120, 21600, 22080, 22560, 
		23040, 23520, 24000
	];
	for (let i = 20; i<200; i++) {
	  weightPricesAir.push(weightPricesAir[i - 1] + 500);
	}
  
	// const weightPricesSea = [
	//   0, 450, 600, 850, 1260, 1400, 1650, 1850, 2150, 2350, 2500, 2850, 3100, 3450, 3650, 3800, 3950, 4050, 4250, 4500,
	//   4850, 5050, 5350, 5750, 5950, 6150, 6500, 6750, 6900, 7150, 7350, 7500, 7850, 8050, 8150, 8250, 8450, 8660, 8850,
	//   8900, 8950, 9050, 9280, 9450, 9620, 9850, 9950, 10080, 10250, 10450, 10700
	// ];
	const weightPricesSea = [
		500, 850, 1050, 1250, 1500, 1750, 2000, 2250, 2650, 3050, 3350, 3650, 3950, 
		4250, 4550, 4850, 5150, 5450, 5750, 5900, 6100, 6300, 6500, 6700, 6900, 
		7100, 7300, 7500, 7700, 7900, 8100, 8300, 8500, 8700, 8900, 9100, 9300, 
		9500, 9700, 9900, 10000, 10150, 10250, 10450, 10600, 10750, 10800, 10950, 
		11100, 11250, 11400, 11550, 11700, 11850, 12000, 12150, 12300, 12450, 12600, 
		12750, 12900, 13050, 13200, 13350, 13500, 13650, 13800, 13950, 14100, 14250, 
		14400, 14550, 14600, 14850, 15000, 15150, 15300, 15450, 15600, 15750
	];
  
	for (let i = 50; i<200; i++) {
	  weightPricesAir.push(weightPricesAir[i - 1] + 300);
	}
  
	const gctAndDuties = [
	  {
		name: 'Jewelery',
		fees: {
		  duty: 1.00,
		  gct: 0.15
		}
	  },
	  {
		name: 'Solar Batteries (Lithium), Inverters, Panels',
		fees: {
		  duty: 0.00,
		  gct: 0.00
		}
	  },
	  {
		name: 'Equipment (Powered Tools)',
		fees: {
		  duty: 0.20,
		  gct: 0.15
		}
	  },
	  {
		name: 'Televisions',
		fees: {
		  duty: 0.20,
		  gct: 0.15
		}
	  },
	  {
		name: 'Motor Vehicle Parts',
		fees: {
		  duty: 0.30,
		  gct: 0.15
		}
	  },
	  {
		name: 'Clothes/Accessories/Fashion',
		fees: {
		  duty: 0.20,
		  gct: 0.15
		}
	  },
	  {
		name: 'Baby Seat, NO duty',
		fees: {
		  duty: 0.00,
		  gct: 0.15
		}
	  },
	  {
		name: 'Computers/Tablets/Computer Parts',
		fees: {
		  duty: 0.00,
		  gct: 0.15
		}
	  },
	  {
		name: 'Electronics/Cell Phones',
		fees: {
		  duty: 0.20,
		  gct: 0.25
		}
	  },
	  {
		name: 'Furniture/Household Items',
		fees: {
		  duty: 0.30,
		  gct: 0.15
		}
	  },
	  {
		name: 'Musical Equipment',
		fees: {
		  duty: 0.00,
		  gct: 0.00
		}
	  },
	];

	// Sort the array by 'name'
	gctAndDuties.sort((a, b) => a.name.localeCompare(b.name));
  
	let form = {
	  itemValue: 100,
	  freightType: 'air',
	  weight: 0,
	  dutyCategory: 0
	};
  
	let results = {
	  dutyCost: 0,
	  scfCost: 0,
	  envlCost: 0,
	  cafCost: 0,
	  gctCost: 0,
	  stampDuty: 0,
	  freightCost: 0,
	  customsCharge: 0,
	  processingFees: 0,
	  gct: 0,
	  estimatedCharge: 0,
	  cif: 0
	};

	function toggleDetails(){
		displayDetails = !displayDetails;
		if (displayDetails){
			document.getElementById("details").style.display = "block";
		}else{
			document.getElementById("details").style.display = "none";
		}
	}
  
	function calculate() {
		// results.dutyCost =
		// form.itemValue > 100
		//   ? Number(form.itemValue * gctAndDuties[form.dutyCategory].fees.duty * exchangeRate).toFixed(2)
		//   : 0;
		results.cafCost = form.itemValue > 100 ? 2500 : 0; //CONSTANT
		results.stampDuty = form.itemValue > 100 ? 100 : 0; //CONSTANT
		results.freightCost = calculateFreightCost();


		results.cif = (form.itemValue * exchangeRate) + results.freightCost;
		results.envlCost = form.itemValue > 100 ? Number(results.cif * 0.005).toFixed(2) : 0; //correct
		results.scfCost = form.itemValue > 100 ? Number(results.cif * 0.003).toFixed(2) : 0; //correct
		results.dutyCost = Number(results.cif * gctAndDuties[form.dutyCategory].fees.duty).toFixed(2);

		results.gctCost = Number((results.cafCost + parseFloat(results.envlCost) + parseFloat(results.scfCost) 
								+ parseFloat(results.dutyCost) + parseFloat(results.cif)) 
								* gctAndDuties[form.dutyCategory].fees.gct).toFixed(2); //correct using spreadsheet and 

		//duty charge + gct = customs charge
	  
	// //   results.scfCost = form.itemValue > 50 ? Number(form.itemValue * 0.4584).toFixed(2) : 0;
	// //   results.envlCost = form.itemValue > 50 ? Number(form.itemValue * 0.764).toFixed(2) : 0;
	
	// results.envlCost = form.itemValue > 50 ? Number(form.itemValue * 0.9075).toFixed(2) : 0; //correct
	  
	//   results.gctCost = Number((results.cafCost + parseFloat(results.envlCost) + parseFloat(results.scfCost) + parseFloat(results.dutyCost))).toFixed(2);
	//   console.log(results.cafCost, results.envlCost, results.scfCost, results.dutyCost);
	//   //results.gctCost = ((results.cafCost + results.envlCost + results.scfCost + results.dutyCost) * 0.15);
	  
	  results.customsCharge =
		form.itemValue > 100
		  ? (Number(results.dutyCost) +
			Number(results.scfCost) +
			Number(results.envlCost) +
			Number(results.cafCost) +
			Number(results.gctCost) 
			+ Number(results.stampDuty)).toFixed(2)
		  : 0;

  
	  
	  if (form.freightType === "air") {
		results.processingFees = 0;
	  } else {
		results.processingFees = exchangeRate * 2.50
	  }
  
	  results.estimatedCharge = Number(
		parseFloat(results.freightCost) + parseFloat(results.customsCharge)
	  ).toFixed(2);

	//   results.estimatedCharge = Number(
	// 	parseFloat(results.envlCost) + parseFloat(results.cafCost) + parseFloat(results.scfCost) + parseFloat(results.gctCost) + parseFloat(results.stampDuty)
	//   ).toFixed(2);
	}
  
	function calculateFreightCost() {
	  let freight = 0;
	  let extraWeight = 0;
	  let extraFee = 0;
  
	  if (form.freightType === 'air') {
		if (form.weight <= 20) {
		  freight = weightPricesAir[form.weight];
		} else {
		  extraWeight = form.weight - 20;
		  extraFee = extraWeight * 500;
		  freight = Number(weightPricesAir[20]) + extraFee;
		}
	  }
  
	  if (form.freightType === 'sea') {
		if (form.weight <= 50) {
		  freight = weightPricesSea[form.weight];
		} else {
		  extraWeight = form.weight - 50;
		  extraFee = extraWeight * 300;
		  freight = Number(weightPricesSea[50]) + extraFee;
		}
	  }
  
	  return freight;
	}

	function formatCosts(number){
		if (number >= 1000) {
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
		return number.toString();
	}
  </script>
  
  <main style="padding-top: 20px;">
	<div>
	  <div class="column">
		<div class="form-group">
		  <label for="" style="font-weight: bold;">Item Value (USD)</label>
		  <input bind:value={form.itemValue} type="text" name="" id="" />
		</div>
  
		<div class="form-group">
		  <label for="" style="font-weight: bold;">Freight Type</label>
		  <select bind:value={form.freightType} name="" id="">
			<option value="air">Air</option>
			<option value="sea">Sea</option>
		  </select>
		</div>
  
		<div class="form-group">
		  <label for="" style="font-weight: bold;">Weight (lbs)</label>
		  <!-- <input bind:value={form.weight} type="number" name="" id="" /> -->
		  <select bind:value={form.weight} name="" id="">
			{#if form.freightType === 'air'}
			  {#each weightPricesAir as price, idx}
			  	<!-- {#if idx != 0} -->
					<option value={idx}>{idx + 1}: ${formatCosts(price)}</option>
				<!-- {/if} -->
			  {/each}
			{:else}
			  {#each weightPricesSea as price, idx}
			  <!-- {#if idx != 0} -->
			  	<option value={idx}>{idx + 1}: ${formatCosts(price)}</option>
		  		<!-- {/if} -->
			  {/each}
			{/if}
		  </select>
		</div>
  
		<div class="form-group">
		  <label for="" style="font-weight: bold;">Duty Category</label>
		  <select bind:value={form.dutyCategory} name="" id="">
			{#each gctAndDuties as duty, idx}
			  <option value={idx}>{duty.name}</option>
			{/each}
			<!-- <option value="">Select Duty...</option>
			<option bind:value= "{gctAndDuties.}"> 0% Duty, 15%GCT : PRINTED TEXTBOOKS AND MAGAZINES </option>
			<option value="1"> 0% Duty, 15%GCT : TABLET/LAPTOP, COMPUTER ACCESSORIES, PRINTER,TOOLS; MACHINERY </option>
			<option value="2"> 5% Duty, 15%GCT : CLOCK / WATCH PARTS ; SINKS AND BASINS; SAFETY PINS </option>
			<option value="3"> 10% Duty, 15%GCT : EXERCISE OR SPORT EQUIPMENT &amp; ACCESSORIES </option>
			<option value="4">
			  15% Duty, 15%GCT : SEWING ACCESSORIES, PACKAGING MATERIALS: SACKS, BAGS; EGG TRAY
			</option>
			<option value="5"> 20% Duty, 15%GCT : MERCHANDIZE - GENERAL COMMODITY </option>
			<option value="6">
			  20% Duty, 15%GCT : FOOD OR DIETARY SUPPLEMENTS,CLOTHING,FOOTWEAR,HANDBAG,JEWELLERY,BACKPACK,CHRISTMAS
			  DECORATIONS,TOILETRIES,BODY SPRAY,PERFUME,HOUSEHOLD ITEMS,FURNITURE,ELECTRICAL APPLIANCES
			</option>
			<option value="7"> 20% Duty, 25%GCT : CELLPHONE </option>
			<option value="8"> 25% Duty, 15%GCT : SOUND MIXERS (FOR DOMESTIC USE) </option>
			<option value="9"> 30% Duty, 15%GCT : AUTO PARTS AND ACCESSORIES </option> -->
		  </select>
		</div>
  
		
	  </div>
		<div style="display: grid; align-items: center; gap:5px;">
			<button class="rounded-button"  on:click={calculate}> Calculate </button>
  
			<span class="disclaimer">
			  Disclaimer: Packages values over 100 USD are subject to customs duties. 
			</span>
			<h3>Estimated Charge: <span class="charge">${formatCosts(results.estimatedCharge)} JMD</span></h3>
			<button class="rectangular-button" on:click={toggleDetails}>Cost Breakdown</button>
		</div>
	  	
		
	  <div class = "details" style="display: none;" id="details">
		<div class="column">
			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px; flex-wrap:nowrap">
				<label for="" style="font-weight: bold; flex-shrink:0;">Estimate in details</label>
				<label for="" style="font-weight: bold; flex-shrink:0;">(JMD)</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">Duty Cost:</label>
				<label for="" style="font" >${formatCosts(results.dutyCost)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">SCF Cost:</label>
				<label for="" style="font" >${formatCosts(results.scfCost)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">ENVL Cost:</label>
				<label for="" style="font" >${formatCosts(results.envlCost)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">CAF Cost:</label>
				<label for="" style="font" >${formatCosts(results.cafCost)}</label>
			</div>
			
			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">GCT Cost:</label>
				<label for="" style="font" >${formatCosts(results.gctCost)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">Stamp Duty:</label>
				<label for="" style="font" >${formatCosts(results.stampDuty)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">Freight Cost:</label>
				<label for="" style="font" >${formatCosts(results.freightCost)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">Customs Charge:</label>
				<label for="" style="font" >${formatCosts(results.customsCharge)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">Processing Fees:</label>
				<label for="" style="font" >${formatCosts(results.processingFees)}</label>
			</div>

			<div class="row" style="display: flex; justify-content: space-between; margin-top:5px">
				<label for="">Other Charges:</label>
				<label for="" style="font" >${formatCosts(results.gct)}</label>
			</div>

		</div> <!-- column  -->
	  </div> <!-- details  -->
	</div>
  </main>
  
  <style>
	main {
	  max-width: 1280px;
	  margin: 0 auto;
	  width: 100%;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  background-color: #cce7f3;
	}
  
	.flex {
	  gap: 2rem;
	  display: flex;
	}
	.column {
	  gap: 1rem;
	  flex-direction: column;
	  flex: 1;
	}
	.row {
	  display: flex;
	  gap: 1rem;
	  flex-direction: row;
	}
	.form-group {
	  width: 100%;
	  margin-bottom: 1rem;
	  display: flex;
	  flex-direction: column;
	  gap: 0.5rem;
	}
	label {
	  font-size: 0.95em;
	}
	input,
	select{
	  width: 100%;
	  border-radius: 10px;
	  padding-left: 10px;
	}

	#details{
	  background-color: white;
	  border-radius: 25px;
	  padding: 15px;
	  margin-bottom: 25px;
	  padding-left: 20px;
	  padding-right: 20px;
	}
  
	button {
	  margin-top: 1.425rem;
	  width: 75%;
	}
	.rounded-button {
    border-radius: 10px; /* Makes the button rounded */
    padding: 10px 20px; /* Adjust padding as necessary */
    border: 1px solid #ccc;
    background-color: #007bff; /* Button background color */
    color: white;
    cursor: pointer;
	justify-self: center;
	background-image: linear-gradient(to right, 
	#2971d5 0%, #0eb1f4  51%, 
	#2971d5  100%);
	transition: 0.5s;
            background-size: 200% auto;
			display: block;
			color: white; 
  }
  /*

           
                 
         .btn-grad {
            background-image: linear-gradient(to right, #24C6DC 0%, #514A9D  51%, #24C6DC  100%);
            margin: 10px;
            padding: 15px 45px;
            text-align: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            color: white;            
            box-shadow: 0 0 20px #eee;
            border-radius: 10px;
            display: block;
          }

         
         


  */

  .rectangular-button {
    border-radius: 0px; /* Makes the button rectangular (no rounded corners) */
	display: flex;
    padding: 10px 20px;
	align-items: center;
	justify-content: center;
	background-color: #e0e0e0;
	line-height: 100%;
	color: black;
	margin-bottom: 25px;
	justify-self: center;

	
    /* background-color: #28a745; Button background color */
    cursor: pointer;
  }

  .rectangular-button span {
	margin-left: 10px;
  }
  
	@media screen and (max-width: 1080px) {
	  main {
		box-sizing: border-box;
		width: 100%;
		padding: 1rem;
	  }
  
	  .flex, .column {
		display: flex;
		flex-direction: column;
	  }
	  .row {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	  }
	}
  </style>
  